import { Button } from '@1trading/react';
import { config } from '@/lib/env';
import { isPreloadReloadPending } from '@/lib/preload-reload';

export const AppErrorFallback = ({ error }: { error: unknown }) => {
  // A stale-chunk reload is already in flight — don't flash the error UI.
  if (isPreloadReloadPending()) {
    return <div className="grid h-dvh place-items-center text-muted-foreground">Loading…</div>;
  }

  return (
    <div className="grid h-dvh place-items-center p-6">
      <div className="flex max-w-lg flex-col items-center gap-4 text-center">
        <h1 className="text-2xl font-semibold">Something went wrong</h1>
        <p className="text-muted-foreground">An unexpected error occurred. Refresh the page to continue.</p>
        <Button onClick={() => window.location.reload()}>Refresh</Button>
        {config.IS_NON_PROD ? <pre className="max-w-full overflow-auto rounded-md border p-4 text-left text-xs">{String(error)}</pre> : null}
      </div>
    </div>
  );
};
AppErrorFallback.displayName = 'AppErrorFallback';
